module.exports = __webpack_public_path__ + "img/paper04.4226d114.jpeg";